const React = require("react");
function IconListCheck(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    fill: props.fill || "#232323",
    height: props.size || 12,
    size: props.size || 24,
    width: 12 * (props.size * 100 / 12) / 100 || 12
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.81818 8.65916.954545 5.79552 0 6.75007l3.81818 3.81813L12 2.38643l-.9545-.95455z"
  }));
}
module.exports = IconListCheck;